import { useEffect, useState } from 'react';

/**
 * Bascule table/carte de `DataTable` sous le breakpoint Tailwind `md`
 * (`README-shell.md` : « tableaux qui passent en cartes sur petit écran »).
 *
 * Valeur initiale calculée de façon synchrone (`useState(() => …)`, pas un
 * `useEffect` qui partirait d'une valeur par défaut) pour éviter un flash
 * table → carte (ou l'inverse) au premier rendu — l'app est une SPA pure
 * (`createRoot`, `main.tsx`), donc `window` est toujours disponible au rendu.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    setMatches(mediaQueryList.matches);

    function handleChange(event: MediaQueryListEvent): void {
      setMatches(event.matches);
    }

    mediaQueryList.addEventListener('change', handleChange);
    return () => {
      mediaQueryList.removeEventListener('change', handleChange);
    };
  }, [query]);

  return matches;
}
